/* © ИП Коробкин И.Н., KIN DIGITAL CRM+ */
import { useMutation } from '@tanstack/react-query';
import QRCode from 'qrcode';
import { useState } from 'react';
import { Button, ErrorText, Field, Input, PageHeader } from '@/components/ui';
import { api } from '@/lib/api';
import { useAuth } from '@/lib/auth';

export function ProfilePage() {
  const { me } = useAuth();
  const [pw, setPw] = useState({ current: '', next: '' });
  const [qr, setQr] = useState<string | null>(null);
  const [secret, setSecret] = useState('');
  const [code, setCode] = useState('');
  const change = useMutation({ mutationFn: () => api.post('/auth/password', pw), onSuccess: () => setPw({ current: '', next: '' }) });
  const setup = useMutation({
    mutationFn: () => api.post('/auth/totp/setup'),
    onSuccess: async (r) => { setSecret(r.secret); setQr(await QRCode.toDataURL(r.otpauth, { margin: 1, width: 200 })); },
  });
  const enable = useMutation({ mutationFn: () => api.post('/auth/totp/enable', { code }), onSuccess: () => { setQr(null); setCode(''); } });
  return (
    <>
      <PageHeader title={me!.fullName} subtitle={me!.email} />
      <div className="grid gap-5 lg:grid-cols-2">
        <section className="card space-y-3 p-4">
          <h2 className="text-sm font-semibold">Смена пароля</h2>
          <Field label="Текущий пароль"><Input type="password" value={pw.current} onChange={(e) => setPw({ ...pw, current: e.target.value })} /></Field>
          <Field label="Новый пароль" hint="Не короче 10 символов, буквы и цифры"><Input type="password" value={pw.next} onChange={(e) => setPw({ ...pw, next: e.target.value })} /></Field>
          <ErrorText error={change.error} />
          {change.isSuccess && <div className="text-sm text-green-700">Пароль изменён. На других устройствах потребуется войти заново.</div>}
          <Button onClick={() => change.mutate()} disabled={!pw.current || !pw.next}>Сменить пароль</Button>
        </section>
        <section className="card space-y-3 p-4">
          <h2 className="text-sm font-semibold">Двухфакторная защита</h2>
          <p className="text-sm text-slate-600">Код из приложения (Яндекс Ключ, Google Authenticator) при каждом входе.</p>
          {!qr ? <Button variant="secondary" onClick={() => setup.mutate()}>Настроить</Button> : (
            <div className="space-y-3">
              <img src={qr} alt="QR-код для приложения" className="h-48 w-48" />
              <div className="text-xs text-slate-500">Или введите ключ вручную: <code>{secret}</code></div>
              <Field label="Код из приложения"><Input inputMode="numeric" maxLength={6} value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))} /></Field>
              <ErrorText error={enable.error} />
              <Button onClick={() => enable.mutate()} disabled={code.length !== 6}>Включить</Button>
            </div>
          )}
          {enable.isSuccess && <div className="text-sm text-green-700">Двухфакторная защита включена.</div>}
        </section>
      </div>
    </>
  );
}
